import { JSX } from 'react';
import { Step } from '../../models/platform';
import { LinkTransform, StepCopyLink, StepDownloadApp, StepImportLink, StepLaunchInstruction } from './SetupSteps';

// ==============================
// Step type definitions
// ==============================
interface DownloadAppStep {
    type: 'DownloadApp';
    appName: string;
    storeName: string;
    link: string;
    img?: string;
}

interface ImportLinkStep {
    type: 'ImportLink';
    importUri: string;
    linkTransform?: LinkTransform;
    fallbackCopyInstruction?: AnyStep[];
}

interface CopyLinkStep {
    type: 'CopyLink';
    linkTransform?: LinkTransform;
    img?: string;
}

interface LaunchInstructionStep {
    type: 'LaunchInstruction';
    instruction: string;
    img?: string;
}

export type AnyStep = DownloadAppStep | ImportLinkStep | CopyLinkStep | LaunchInstructionStep;

// ==============================
// Рендер шагов через отдельные компоненты
// ==============================
const stepRenderers: Record<AnyStep['type'], (step: AnyStep, link?: string) => JSX.Element> = {
	DownloadApp: (s) => {
		const step = s as DownloadAppStep;
		return (
			<StepDownloadApp
				key={`download-${step.appName}`}
				appName={step.appName}
				storeName={step.storeName}
				link={step.link}
				img={step.img}
			/>
		);
	},

	ImportLink: (s, link) => {
		const step = s as ImportLinkStep;
		return (
			<StepImportLink
				key={`import-${step.importUri}`}
				importUri={step.importUri}
				link={link}
				linkTransform={step.linkTransform}
				fallbackCopyInstruction={step.fallbackCopyInstruction?.map((nested) =>
					renderStep(nested, link)
				)}
			/>
		);
	},

	CopyLink: (s, link) => {
		const step = s as CopyLinkStep;
		return (
			<StepCopyLink
				key={`copy-${link}`}
				linkTransform={step.linkTransform}
				copyLink={link}
				img={step.img}
			/>
		);
	},

	LaunchInstruction: (s) => {
		const step = s as LaunchInstructionStep;
		return (
			<StepLaunchInstruction key={`instr-${step.instruction}`} instruction={step.instruction} img={step.img} />
		);
	},
};

export function renderStep(step: Step | AnyStep, link?: string): JSX.Element {
	const renderer = stepRenderers[step.type as AnyStep['type']];
	if (!renderer) {
		console.warn('Unknown step type:', step.type);
		return <></>;
	}
	return renderer(step as AnyStep, link);
}
